import React from 'react';
import axios from 'axios';
import url from '../config';
import { FETCH_FOLLOWUP_LEADS_SUCCESS, FETCH_FOLLOWUP_MAPPING, FETCH_FOLLOWUP_LEAD_DETAIL_SUCCESS, FETCH_FOLLOWUP_LEAD_COMMENTS_SUCCESS, FETCH_FOLLOWUP_TASKS_SUCCESS, FETCH_FOLLOWUP_LEAD_TASKS_SUCCESS, FETCH_FOLLOWUP_LEAD_HISTORY_SUCCESS } from './actiontypes';

export function fetchAllLeads() {
    return async (dispatch) => {
        try {
            let response = await axios.post(`${url.pathBackend}sales/followup/getFollowupLeads`);
            response = response.data;
            if (response.error) {
                alert(response.error || "Some Error Ocurred");
                return;
            }
            let leadsData = response.data;
            dispatch({ type: FETCH_FOLLOWUP_LEADS_SUCCESS, payload: leadsData || [] });
        }
        catch (e) {
            console.log(e);
        }
    }
}

export function fetchAllLeadsDesktop(filters = {}) {
    return async (dispatch) => {
        try {
            let response = await axios.post(`${url.pathBackend}sales/followup/fetchFollowUpDesktop`, filters);
            response = response.data;
            if (response.error) {
                alert(response.error || "Some Error Ocurred");
                return;
            }
            let { followUpData = [], mapping = {} } = response;
            dispatch({ type: FETCH_FOLLOWUP_LEADS_SUCCESS, payload: followUpData || [] });
            dispatch({ type: FETCH_FOLLOWUP_MAPPING, payload: mapping || {} });
            console.log(mapping);
        }
        catch (e) {
            console.log(e);
        }
    }
}

export function fetchFollowupTasks(filters = {}) {
    return async (dispatch) => {
        try {
            let response = await axios.post(`${url.pathBackend}sales/followup/fetchFollowupTasks`, {filters});
            response = response.data;
            if (response.error) {
                alert(response.error || "Some Error Ocurred");
                return;
            }
            let { tasks = [] } = response;
            dispatch({ type: FETCH_FOLLOWUP_TASKS_SUCCESS, payload: tasks || [] });
        }
        catch (e) {
            console.log(e);
        }
    }
}

export function fetchLeadDetailFollowup(leadId) {
    return async (dispatch) => {
        try {
            let response = await axios.post(`${url.pathBackend}sales/followup/fetchFollowUpLead`, { leadId });
            response = response.data;
            if (response.error) {
                alert(response.error || "Some Error Ocurred");
                return;
            }
            let { leadData = {}, mapping = {}, comments = [], tasks = [], leadHistory = [] } = response;
            dispatch({ type: FETCH_FOLLOWUP_LEAD_DETAIL_SUCCESS, payload: leadData || [] });
            dispatch({ type: FETCH_FOLLOWUP_MAPPING, payload: mapping || {} });
            dispatch({ type: FETCH_FOLLOWUP_LEAD_COMMENTS_SUCCESS, payload: comments || [] })
            dispatch({ type: FETCH_FOLLOWUP_LEAD_TASKS_SUCCESS, payload: tasks || [] })
            dispatch({ type: FETCH_FOLLOWUP_LEAD_HISTORY_SUCCESS, payload: leadHistory || [] })
            console.log(leadHistory)
            console.log(mapping);
        }
        catch (e) {
            console.log(e);
        }
    }
}

export function fetchMapping() {
    return async (dispatch) => {
        try {
            let response = await axios.post(`${url.pathBackend}sales/followup/mapping`);
            response = response.data || {};
            dispatch({ type: FETCH_FOLLOWUP_MAPPING, payload: response || {} });
        }
        catch (e) {
            console.log(e);
        }
    }
}

export function updateLeadData(leadData, updatedLeadData, commentAdded = false) {
    return async (dispatch) => {
        try {
            let updateData = {};
            Object.keys(updatedLeadData).forEach(key => {
                if(updatedLeadData[key] != leadData[key]) {
                    updateData[key] = updatedLeadData[key];
                }
            })
            if(!Object.keys(updateData).length) {
                console.log("no data to update");
                return;
            } 
            console.log({
                leadId: leadData.BITRIX_ID,
                updateData: updateData,
                QUOTE_ID: updatedLeadData.QUOTE_ID
            })
            // return;
            let response = await axios.post(`${url.pathBackend}sales/followup/updateLead`, {
                leadId: leadData.BITRIX_ID,
                updateData: updateData,
                quoteId: updatedLeadData.QUOTE_ID
            });
            response = response.data || {};
            console.log(response);
            if(commentAdded) return;
            if(response.success) {
                alert("Updated");
                return;
            }
            else {
                alert("some error occured");
                return;
            }
        }
        catch (e) {
            console.log(e);
        }
    }
}
